import api from '../api/client';
// components/RecentTransactions.js
import React from 'react';
import DataTable from 'react-data-table-component';
import { formatKES } from '../utils/currency';

const RecentTransactions = ({ transactions }) => {
    const columns = [
        {
            name: 'Date',
            selector: (row) => new Date(row.transaction_date).toLocaleDateString(),
            sortable: true,
            width: '130px'
        },
        {
            name: 'Description',
            selector: (row) => row.description,
            sortable: true,
            width: '30%'
        },
        {
            name: 'Debit',
            selector: (row) => row.debit_name
        },
        {
            name: 'Credit',
            selector: (row) => row.credit_name
        },
        {
            name: 'Amount',
            selector: (row) => formatKES(row?.amount),
            sortable: true,
            cell: (row) => <span className={row.amount >= 0 ? 'text-green-600' : 'text-red-600'}>{formatKES(row.amount)}</span>,
            right: true
        }
    ];

    return (
        <div className="overflow-x-auto">
            <DataTable
                columns={columns}
                data={transactions}
                pagination
                highlightOnHover
                striped
                bordered
                paginationPerPage={20}
                paginationRowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                paginationComponentOptions={{
                    rowsPerPageText: 'Rows per page:'
                }}
                paginationResetDefaultPage={true}
                paginationTotalRows={transactions.length}
                customStyles={{
                    headRow: {
                        style: {
                            backgroundColor: '#279e6c', // Green background
                            color: '#fff', // White text
                            textTransform: 'uppercase', // Uppercase text
                            // fontSize: '10px', // Adjust font size for header row
                            minHeight: '1.5rem',
                            paddingTop: '8px',
                            paddingBottom: '8px'
                        }
                    }
                }}
            />
        </div>
    );
};

export default RecentTransactions;
